export interface ManhwaWork {
  id: string;
  title: string;
  original: string;
  genres: string[];
  tags: string[];
  rating: number;
  popularity: number;
  status: "连载中" | "已完结";
  episodes: string;
  summary: string;
  synopsis: string;
  image: string;
}

export const WORKS: ManhwaWork[] = [
  {
    id: "solo-leveling",
    title: "我独自升级",
    original: "나 혼자만 레벨업 / Solo Leveling",
    genres: ["玄幻", "冒险"],
    tags: ["猎人", "系统流", "爽文"],
    rating: 9.6,
    popularity: 986,
    status: "已完结",
    episodes: "179 话",
    summary: "十年前觉醒猎人的男主，凭借隐藏的「玩家」系统从最弱E级一路攀升，成为改写世界的唯一强者。",
    synopsis:
      "在人类与魔物共存的十年里，猎人们靠觉醒之力守护世界。被称为「人类最弱兵器」的E级猎人成振宇在一次地下城任务中濒死，却意外获得了名为「玩家」的神秘系统——通过不断挑战副本累积经验，等级无上限。他一边隐藏实力一边攀升，从无人问津的小猎人成长为足以撼动世界的暗影君主。",
    image:
      "https://readdy.ai/api/search-image?query=dark%20fantasy%20Korean%20webtoon%20cover%20art%20of%20a%20young%20hunter%20with%20shadowy%20armor%20and%20glowing%20violet%20system%20windows%2C%20silhouette%20facing%20a%20giant%20blue%20dimensional%20door%20in%20a%20ruined%20dungeon%2C%20dramatic%20rim%20lighting%2C%20vibrant%20illustration%2C%20cinematic%20composition%2C%20high%20detail&width=600&height=800&seq=cover-solo&orientation=portrait",
  },
  {
    id: "tower-of-god",
    title: "神之塔",
    original: "신의 탑 / Tower of God",
    genres: ["奇幻", "冒险"],
    tags: ["闯关", "群像", "伏笔"],
    rating: 9.4,
    popularity: 921,
    status: "连载中",
    episodes: "620+ 话",
    summary: "传说登顶神之塔即可实现任何愿望，少年夜为追寻挚友闯入塔内，展开险象环生的攀塔之旅。",
    synopsis:
      "一座直入云端的神秘高塔，传说只要登上塔顶，任何愿望都能实现。为追回突然消失的好友蕾哈儿，少年夜义无反顾地踏入塔中。塔内每一层都是生死试炼，无数规则与势力盘根错节。夜在同伴与敌人的夹缝中一步步往上，也逐渐触碰到关于塔与自己的巨大秘密。",
    image:
      "https://readdy.ai/api/search-image?query=Korean%20webtoon%20cover%20art%20of%20a%20massive%20spiral%20tower%20reaching%20into%20clouds%2C%20tiny%20hero%20silhouette%20climbing%20floating%20stone%20platforms%2C%20warm%20golden%20and%20teal%20light%2C%20epic%20fantasy%2C%20mysterious%20atmosphere%2C%20vibrant%20illustration%2C%20high%20detail%20cinematic&width=600&height=800&seq=cover-tower&orientation=portrait",
  },
  {
    id: "omniscient-reader",
    title: "全知读者视角",
    original: "전지적 독자 시점 / Omniscient Reader",
    genres: ["玄幻", "冒险"],
    tags: ["小说改编", "末世", "穿越"],
    rating: 9.5,
    popularity: 948,
    status: "连载中",
    episodes: "220+ 话",
    summary: "世界骤然沦为小说中的末世，唯一读过整本「完本小说」的读者金独子，凭着剧透走向改写命运的尽头。",
    synopsis:
      "作家的小说《灭活法》连载十年终于完结，唯一从头追到尾的读者金独子，在现实世界毁灭的瞬间成为唯一个「读过全本」的人。当末世降临、剧情照本宣科地上演，他凭借对剧情的全知视野，在死亡与背叛之间步步为营，把「读者」的身份化作最致命的外挂。",
    image:
      "https://readdy.ai/api/search-image?query=Korean%20webtoon%20cover%20art%20of%20a%20lone%20man%20holding%20a%20glowing%20magic%20book%20while%20a%20collapsed%20apocalyptic%20city%20burns%20behind%20him%2C%20blue%20and%20orange%20contrast%2C%20dramatic%20stormy%20sky%2C%20mysterious%20tone%2C%20vibrant%20illustration%2C%20high%20detail%20cinematic&width=600&height=800&seq=cover-reader&orientation=portrait",
  },
  {
    id: "god-of-high-school",
    title: "高校之神",
    original: "갓 오브 하이스쿨 / The God of High School",
    genres: ["动作", "格斗"],
    tags: ["武道", "大赛", "热血"],
    rating: 9.0,
    popularity: 874,
    status: "连载中",
    episodes: "560+ 话",
    summary: "全国高校武道大会汇聚各路少年强者，格斗天才陈毛利向「最强」发起冲击，赛事背后却暗流涌动。",
    synopsis:
      "韩国全国高校武道大赛开幕，来自各地的高中生以拳会友、各展神通。天生好战的主角陈毛利为求最强一路闯关，与队友结识并肩，却在赛事背后逐渐发现，这场大会不过是某个庞大阴谋的舞台。热血格斗与神话元素的碰撞就此展开。",
    image:
      "https://readdy.ai/api/search-image?query=Korean%20webtoon%20cover%20art%20of%20a%20teenage%20martial%20artist%20in%20dynamic%20fighting%20stance%20with%20crackling%20golden%20energy%20around%20his%20fists%2C%20sparring%20dojo%20arena%20background%2C%20intense%20motion%20lines%2C%20warm%20orange%20and%20gold%20tones%2C%20vibrant%20illustration%2C%20high%20detail&width=600&height=800&seq=cover-god-high&orientation=portrait",
  },
  {
    id: "sweet-home",
    title: "甜蜜家园",
    original: "스위트홈 / Sweet Home",
    genres: ["恐怖", "末世"],
    tags: ["怪物", "生存", "治愈"],
    rating: 8.8,
    popularity: 839,
    status: "已完结",
    episodes: "140 话",
    summary: "一栋公寓在怪物横行中沦为孤岛，内向少年车贤秀在末世求生里直面欲望，也重新找回活着的意义。",
    synopsis:
      "世界爆发神秘变异，人类内心的欲望化作形形色色的怪物。失去家人、一心求死的少年车贤秀搬进一间公寓，却在怪物潮与人性考验中一次次挣扎求生。公寓里的住户在绝望中相互扶持，也彼此猜忌。当怪物的真相逐渐揭开，活下来本身成为最艰难的执念。",
    image:
      "https://readdy.ai/api/search-image?query=Korean%20webtoon%20cover%20art%20of%20a%20grim%20apartment%20corridor%20with%20a%20lone%20young%20man%20holding%20a%20makeshift%20weapon%2C%20shadowy%20monster%20silhouette%20lurking%20in%20darkness%2C%20cold%20blue%20and%20teal%20lighting%2C%20tense%20horror%20atmosphere%2C%20vibrant%20illustration%2C%20high%20detail&width=600&height=800&seq=cover-sweet-home&orientation=portrait",
  },
  {
    id: "true-beauty",
    title: "女神降临",
    original: "여신강림 / True Beauty",
    genres: ["恋爱", "校园"],
    tags: ["化妆", "治愈", "少女心"],
    rating: 8.9,
    popularity: 861,
    status: "连载中",
    episodes: "240+ 话",
    summary: "因外貌自卑的女生任珠景靠化妆「变身」成女神，在秘密与坦诚之间，开启跌跌撞撞的校园恋爱。",
    synopsis:
      "长年被外貌自卑困扰的任珠景，凭借高超化妆术在校园里华丽变身，成为众人口中的「女神」。可越是光鲜，越害怕被看穿素颜的秘密。当两个同样隐藏着伤痛的男孩走进她的生活，爱情、友情与自我认同交织成一段温暖又真实的成长物语。",
    image:
      "https://readdy.ai/api/search-image?query=Korean%20webtoon%20cover%20art%20of%20a%20pretty%20teenage%20girl%20with%20soft%20makeup%20holding%20a%20glowing%20makeup%20brush%2C%20cherry%20blossoms%20and%20warm%20pink%20bokeh%20background%2C%20romantic%20school%20romance%20tone%2C%20gentle%20lighting%2C%20vibrant%20illustration%2C%20high%20detail&width=600&height=800&seq=cover-beauty&orientation=portrait",
  },
  {
    id: "noblesse",
    title: "大贵族",
    original: "노블레스 / Noblesse",
    genres: ["奇幻", "动作"],
    tags: ["吸血鬼", "贵族", "热血"],
    rating: 9.1,
    popularity: 897,
    status: "连载中",
    episodes: "560+ 话",
    summary: "沉眠八百年的贵族吸血鬼卡迪斯苏醒于现代校园，为守护友人卷入血族与人类世界的纷争。",
    synopsis:
      "沉睡了八百年的贵族吸血鬼卡迪斯·艾特拉马·迪·莱杰罗在一所高中苏醒，伪装成学生过着平淡日常。然而当威胁人类的组织悄然逼近他的朋友与校园，这位沉睡的守护者终于苏醒力量，掀起血族、人类与黑暗势力之间的巨大风暴。",
    image:
      "https://readdy.ai/api/search-image?query=Korean%20webtoon%20cover%20art%20of%20an%20elegant%20pale%20noble%20man%20in%20a%20long%20black%20coat%20with%20silver%20hair%20and%20glowing%20red%20eyes%2C%20standing%20in%20a%20moonlit%20gothic%20hall%2C%20blue%20and%20red%20dramatic%20lighting%2C%20refined%20mysterious%20tone%2C%20vibrant%20illustration%2C%20high%20detail&width=600&height=800&seq=cover-noblesse&orientation=portrait",
  },
  {
    id: "see-you-19th-life",
    title: "今生也请多指教",
    original: "이번 생도 잘 부탁해 / See You in My 19th Life",
    genres: ["恋爱", "奇幻"],
    tags: ["转世", "治愈", "温柔"],
    rating: 9.2,
    popularity: 883,
    status: "已完结",
    episodes: "150 话",
    summary: "能带着前世记忆轮回的班瑞，在十八世与文瑞夏相遇后决定「这辈子也要找到他」，展开温暖羁绊。",
    synopsis:
      "班瑞带着完整的前世记忆不断轮回，十八世时她与少年文瑞夏结下难以割舍的缘分，却在意外中匆匆告别。此生再度轮回的她，下定决心「一定要找到他」，跨越时间与记忆，重新走近那个被命运改写的男孩。温柔而漫长的第二次相遇就此开始。",
    image:
      "https://readdy.ai/api/search-image?query=Korean%20webtoon%20cover%20art%20of%20a%20gentle%20woman%20and%20a%20soft%20young%20man%20silhouettes%20meeting%20under%20a%20glowing%20sunset%20sky%20with%20floating%20petals%2C%20warm%20pastel%20pink%20and%20golden%20tones%2C%20romantic%20melancholic%20mood%2C%20vibrant%20illustration%2C%20high%20detail&width=600&height=800&seq=cover-19th&orientation=portrait",
  },
  {
    id: "my-s-class-hunters",
    title: "我培育的S级们",
    original: "내가 키운 S급들 / My S-Class Hunters",
    genres: ["玄幻", "冒险"],
    tags: ["猎人", "治愈", "龙傲天"],
    rating: 9.3,
    popularity: 905,
    status: "连载中",
    episodes: "180+ 话",
    summary: "全人类最弱的F级猎人李汉雅，却握有能「培育」他人成神的隐藏天赋，一步步带出最强团队。",
    synopsis:
      "在这个以猎人等级衡量一切的世界里，李汉雅是全人类公认最弱的F级。但没人知道，他拥有能让他人快速成长的隐藏能力——只要与他并肩，S级猎人也愿称他为老师。被世人嘲笑的弱者，悄然培育出一支足以颠覆猎人行会格局的最强团队。",
    image:
      "https://readdy.ai/api/search-image?query=Korean%20webtoon%20cover%20art%20of%20a%20determined%20young%20hunter%20with%20a%20protective%20team%20of%20powerful%20warriors%20behind%20him%2C%20golden%20energy%20ribbons%20connecting%20them%2C%20ruined%20city%20battlefield%2C%20warm%20orange%20and%20gold%20lighting%2C%20epic%20tone%2C%20vibrant%20illustration%2C%20high%20detail&width=600&height=800&seq=cover-sclass&orientation=portrait",
  },
  {
    id: "lookism",
    title: "看脸时代",
    original: "외모지상주의 / Lookism",
    genres: ["校园", "现实"],
    tags: ["双面人生", "成长", "励志"],
    rating: 9.0,
    popularity: 852,
    status: "连载中",
    episodes: "500+ 话",
    summary: "肥胖自卑的朴亨硕一觉醒来拥有帅气分身，在「两个自己」之间周旋，直面外貌至上的现实世界。",
    synopsis:
      "长期因外貌饱受歧视的朴亨硕，某天发现自己拥有两个可以随意切换的身体——一个帅气满分、一个平凡自卑。他在两副躯壳间体验截然不同的人生，也逐渐看清「看脸时代」背后真实的残酷与温柔。一部关于外貌、自尊与成长的现实写照。",
    image:
      "https://readdy.ai/api/search-image?query=Korean%20webtoon%20cover%20art%20of%20two%20silhouettes%20of%20the%20same%20young%20man%20split%20in%20half%2C%20one%20handsome%20and%20confident%20the%20other%20shy%20and%20overweight%2C%20urban%20school%20street%20background%2C%20mirror%20reflection%20theme%2C%20teal%20and%20orange%20tones%2C%20vibrant%20illustration%2C%20high%20detail&width=600&height=800&seq=cover-lookism&orientation=portrait",
  },
  {
    id: "return-blossom",
    title: "剑尊归来",
    original: "귀환한 칼신 / Return of the Blossoming Blade",
    genres: ["武侠", "奇幻"],
    tags: ["重生", "剑道", "热血"],
    rating: 9.2,
    popularity: 890,
    status: "连载中",
    episodes: "200+ 话",
    summary: "剑道第一人惨死后重生成小辈弟子，带着一世记忆重振没落门派，再战江湖巅峰。",
    synopsis:
      "一代剑尊惨遭围攻陨落，再度睁眼却成了没落门派里最不起眼的小弟子。他带着前世一身绝世剑法重头修炼，以「第一剑客」的骄傲重振门派、快意恩仇。在这个宗门倾颓、群雄并起的武林，一把长剑即将重新刻下他的名字。",
    image:
      "https://readdy.ai/api/search-image?query=Korean%20webtoon%20cover%20art%20of%20a%20young%20swordsman%20in%20traditional%20hanbok%20drawing%20a%20glowing%20sword%20in%20a%20misty%20mountain%20landscape%2C%20falling%20cherry%20blossoms%2C%20teal%20and%20white%20palette%2C%20eastern%20martial%20arts%20fantasy%2C%20dramatic%20lighting%2C%20vibrant%20illustration%2C%20high%20detail&width=600&height=800&seq=cover-blossom&orientation=portrait",
  },
  {
    id: "golden-spoon",
    title: "金汤匙",
    original: "금수저 / The Golden Spoon",
    genres: ["现实", "奇幻"],
    tags: ["阶层", "身份互换", "反思"],
    rating: 8.7,
    popularity: 810,
    status: "已完结",
    episodes: "160 话",
    summary: "穷学生捡到能「交换人生」的金汤匙，与财阀公子互换身份，却在金钱与亲情间迷失自我。",
    synopsis:
      "家境贫寒的学生李承天偶然得到一副神秘的金汤匙，只要用它吃饭就能与一个富人「交换人生」。他毫不犹豫地与财阀公子互换身份，一夜之间从穷人变成天之骄子。可当财富与地位触手可及，他才发现，真正无法交换的，是亲情与内心的底线。",
    image:
      "https://readdy.ai/api/search-image?query=Korean%20webtoon%20cover%20art%20of%20a%20shiny%20golden%20spoon%20glowing%20in%20the%20hand%20of%20a%20poor%20student%2C%20background%20split%20between%20a%20gloomy%20slum%20and%20a%20luxurious%20mansion%2C%20gold%20and%20dark%20contrast%2C%20symbolic%20social%20class%20theme%2C%20vibrant%20illustration%2C%20high%20detail&width=600&height=800&seq=cover-spoon&orientation=portrait",
  },
];

export const GENRES: { name: string; desc: string; count: number }[] = [
  { name: "玄幻", desc: "系统、修炼与力量体系，越追越上头", count: 128 },
  { name: "冒险", desc: "闯关、探索与未知世界的惊险旅程", count: 96 },
  { name: "动作", desc: "热血格斗、激战与武道对决", count: 84 },
  { name: "恋爱", desc: "校园甜蜜与温柔治愈的成长物语", count: 102 },
  { name: "奇幻", desc: "异世界、超能力与魔幻设定", count: 88 },
  { name: "恐怖", desc: "悬疑惊悚与生存绝望的氛围之作", count: 45 },
  { name: "武侠", desc: "东方侠义与剑道恩怨", count: 57 },
  { name: "现实", desc: "写实题材与社会议题的深度刻画", count: 63 },
];